import moment from 'moment'
moment.locale('es_AR')

const FM_DAY = 'dddd DD [de] MMMM'

export default (s) => {
  const min = moment(s.schedule.min)
  const max = moment(s.schedule.max)
  if (Math.abs(min.diff(max, 'days')) == 0) {
    return `Tu pedido llegará el ${max.format(FM_DAY)}.`
  } else {
    return `Tu pedido llegará entre el ${min.format(FM_DAY)} y el ${max.format(FM_DAY)}.`
  }
}